const SearchFieldStylesFiltro = {
    control: (styles) => ({
        ...styles,
        // marginTop: '3px',
        color: '#707070',
        backgroundColor: '#343434',
        borderRadius: "10px",
        padding: "3px",
        minWidth: "200px",
        marginRight: "7px"
    }),
    option: (styles, { isDisabled }) => {
        return {
            ...styles,
            backgroundColor: '#343434',
            color: '#707070',
            border: 'none'
        }
    },
    input: (styles) => ({ ...styles, color: "#707070" }),
    singleValue: (styles) => ({ ...styles, color: "#707070"}),
    multiValue: (styles) => ({ 
        ...styles, 
        color: "whitesmoke", 
        backgroundColor: "#343434", 
        border: "1px solid whitesmoke", 
        borderRadius: "6px" 
    }),
    multiValueLabel: (styles) => ({ ...styles, color: "whitesmoke" }),
    menuList: (styles) => ({ ...styles, backgroundColor: "#343434"}),
}

export { SearchFieldStylesFiltro };